import React from 'react';
import { Table } from 'semantic-ui-react';

const TableHeading = () => (
    <Table.Header>
        <Table.Row>
            <Table.HeaderCell width='one'>Id</Table.HeaderCell>
            <Table.HeaderCell width='one'>Type</Table.HeaderCell>
            <Table.HeaderCell width='one'>File Name</Table.HeaderCell>
            <Table.HeaderCell width='one'>File Path</Table.HeaderCell>
            <Table.HeaderCell width='one'>Created</Table.HeaderCell>
            <Table.HeaderCell width='one'>Status</Table.HeaderCell>
            <Table.HeaderCell width='one'>Response</Table.HeaderCell>
        </Table.Row>
    </Table.Header>
)

export default TableHeading;